module.exports = __WEBPACK_EXTERNAL_MODULE_9__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactRouterDOM","commonjs2":"react-router-dom","commonjs":"react-router-dom","amd":"react-router-dom"}
// module id = 9
// module chunks = 0